'use strict';

var FormView = require('commons/views/Form');

module.exports = FormView.extend({
    tagName:   'div',
    className: 'modal inmodal',

    events: function() {
        var parentEvents = _.isFunction(FormView.prototype.events) ?
            FormView.prototype.events() : FormView.prototype.events;

        return _.extend(_.clone(parentEvents), {
            'hide.bs.modal': 'render',
            'show.bs.modal': 'render',

            /* If we don't stop this datepicker events they bubble up and
             * cause render to loop infinitely
             * */
            'hide .js-datepicker': 'stopEvent',
            'show .js-datepicker': 'stopEvent',

            'hidden.bs.modal': 'hidden',
            'shown.bs.modal':  'shown'
        });
    },

    initialize: function() {
        this.on('saved cancelled destroyed', this.hide, this);
        return FormView.prototype.initialize.apply(this, arguments);
    },

    bindHandlers: function() {
        var r = FormView.prototype.bindHandlers.apply(this, arguments);

        app.events.off(null, null, this);

        return r;
    },

    stopEvent: function(ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
    },

    show: function() {
        this.trigger('show');
        this.$el.modal('show');
    },

    shown: function() {
        this.trigger('shown');
    },

    hide: function() {
        this.trigger('hide');
        this.$el.modal('hide');
    },

    hidden: function() {
        this.trigger('hidden');
    },

    isVisible: function() {
        return this.$el.hasClass('in');
    },

    dirty: function() {
        return (
            this.isVisible() && FormView.prototype.dirty.apply(this, arguments)
        );
    }
});



// WEBPACK FOOTER //
// ./app/commons/views/ModalForm.js